module.exports = __webpack_public_path__ + "static/media/img59.89951da3.jpg";